export default __webpack_public_path__ + "static/carnival-corporation-logo-4a0de4f72d49aed857780c65afda33e2.jpeg";